// lib/client/guestSavedSync.js
'use client';

/**
 * Sync guest saved hearts to authenticated user account
 * Called after login to merge guest shopping cart with wishlist
 */
export async function reconcileGuestSaved() {
  //console.log("reconcileGuestSaved");
  const [{ syncGuestSavedToAuth }, { fetchJson }, { addToQueue }] = await Promise.all([
    import('./interactionCache'),
    import('./fetchJson'),
    import('./offlineQueue'),
  ]);

  // Get all guest saved hearts and sync to authenticated cache
  const guestHeartIds = syncGuestSavedToAuth();

  // No guest saves to sync
  if (!guestHeartIds || guestHeartIds.length === 0) {
    return;
  }

  // Save each heart to server
  await Promise.allSettled(
    guestHeartIds.map(async (heartId) => {
      try {
        await fetchJson(`/api/saved/${heartId}`, {
          method: 'POST',
        });
      } catch (error) {
        console.warn(`Failed to sync guest saved heart ${heartId}:`, error);
        // Queue for later sync if offline or server error
        if (!navigator.onLine || error.status >= 500) {
          addToQueue({
            type: 'save',
            heartId,
          });
        }
      }
    })
  );

  //console.log(`Synced ${guestHeartIds.length} guest saved hearts to account`);
}
